<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg12>
      <v-container fluid>
        <evaloe-results :questionnaire="this.questionnaire" :questionnaireItems="this.questionnaireItems" :recommendations="this.recommended"></evaloe-results>
      </v-container>
    </v-flex>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Results' })"><v-icon>arrow_back</v-icon></v-btn>
  </v-layout>
</template>

<script>
  import EvaloeResults from '../questionnaires/EvaloeResults.vue'
  import {QuestionnaireResource} from '../../api/questionnaire'

  export default {
    name: 'result',
    components: {
      'evaloe-results': EvaloeResults
    },
    data () {
      return {
        questionnaire: {},
        questionnaireItems: [],
        recommended: []
      }
    },
    beforeRouteEnter: function (to, from, next) {
      var qi = []
      QuestionnaireResource().getResponses({id: to.params.questionnaireId}).then(response => {
        qi = response.body
        next(vm => {
          vm.questionnaireItems = qi
        })
      }, response => {
        console.log(response)
        next(false)
      })
    },
    created: function () {
      QuestionnaireResource().get({id: this.$route.params.questionnaireId}).then(response => {
        this.questionnaire = response.body
      }, response => {
        console.log('error' + response.body)
      })
      QuestionnaireResource().getRecommendations({id: this.$route.params.questionnaireId}).then(response => {
        this.recommendations = response.body
      }, response => {
        console.log(response)
      })
      QuestionnaireResource().getRecommended({id: this.$route.params.questionnaireId}).then(response => {
        this.recommended = response.body
      }, response => {
        console.log(response)
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/Result.vue